module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "cip"
  }, [_vm._v("Copyright © 2020, Lesley Choyce")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced, stored in a retrieval system or transmitted in any form or by any means without the prior written permission from the publisher, or, in the case of photocopying or other reprographic copying, permission from Access Copyright, 1 Yonge Street, Suite 1900, Toronto, Ontario M5E 1E5.")]), _vm._v(" "), _c('p', {
    staticClass: "cip-L"
  }, [_vm._v("Nimbus Publishing Limited 3660 Strawberry Hill St, Halifax, NS, B3K 5A9 (902) 455-4286 nimbus.ca")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Printed and bound in Canada")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("NB1439")]), _vm._v(" "), _c('p', {
    staticClass: "cip-L"
  }, [_vm._v("Editor: Angela Mombourquette"), _c('br'), _vm._v("Cover design: Peggy Issenman, Peggy & Co."), _c('br'), _vm._v("Interior design: Rudi Tusek"), _c('br'), _vm._v("Cover photo: iStockphoto.com (shaunl)")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Library and Archives Canada Cataloguing in Publication")]), _vm._v(" "), _c('p', {
    staticClass: "cip-L"
  }, [_vm._v("Title: Saltwater chronicles : notes on everything under the Nova Scotia sun / Lesley Choyce."), _c('br'), _vm._v("Names: Choyce, Lesley, 1951- author."), _c('br'), _vm._v("Identifiers: Canadiana (print) 20200162055 | Canadiana (ebook) 20200162098 | ISBN 9781771088268 (softcover) | ISBN 9781771088275 (HTML)"), _c('br'), _vm._v("Subjects: LCSH: Choyce, Lesley, 1951- | LCSH: Authors, Canadian—20th century—Biography. | LCSH: Nova Scotia—Anecdotes. | LCGFT: Autobiographies."), _c('br'), _vm._v("Classification: LCC PS8555.H668 Z46 2020 | DDC C818/.5409—dc23")]), _vm._v(" "), _c('figure', {
    staticClass: "logo"
  }, [_c('img', {
    staticClass: "fullpic",
    attrs: {
      "alt": "",
      "src": "image/Copyright-3-Logos.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cip _idGenParaOverride-1"
  }, [_vm._v("Nimbus Publishing acknowledges the financial support for its publishing activities from the Government of Canada, the Canada Council for the Arts, and from the Province of Nova Scotia. We are pleased to work in partnership with the Province of Nova Scotia to develop and promote our creative industries for the benefit of all Nova Scotians.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2710f8b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Copyright.vue
// module id = 60
// module chunks = 0